module.exports = __webpack_public_path__ + "img/icon-input-use-chromato.cf1c259f.svg";